import { Tab } from "typings";
import produce from "immer";
import { ServerState } from "../ServerState";
import { TabActions } from "./action";


export interface State extends ServerState<Tab>
{
}

const initialState: State = {
    byId: {}
};


const reducer = (state = initialState, action: TabActions): State => produce(state, draft =>
{
    if (action.type === "LOAD_TABS_SUCCESS")
    {
        const { tabs } = action;
        for (const tab of tabs)
        {
            draft.byId[tab.tabName] = tab;
        }
    }
});

export const getTabs = (state: State): Tab[] => Object.keys(state.byId).map(key => state.byId[key]);


export default reducer;


// WEBPACK FOOTER //
// ./src/state/tab/index.ts